import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState,useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { StyledDropZone } from 'react-drop-zone'
import 'react-drop-zone/dist/styles.css'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import Placeholder from 'react-bootstrap/Placeholder';
import Container from 'react-bootstrap/Container';
import FormText from './../inputs/text';
import FormSelect from './../inputs/select';
import FormFileUpload from "./../inputs/fileupload";

import cloneDeep from 'lodash/cloneDeep';

import { prepareForm } from './../../utils';
import { runInAction, makeAutoObservable } from "mobx"
import Image from 'react-bootstrap/Image'

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';




const CompaniesEdit = () => {

    let navigate = useNavigate();
    const { usersAdminStore, companiesStore, utilsStore, fileStore } = useStores();
    const { getById, company, reset, save } = companiesStore;
    const { uploadImage, filename } = fileStore;
    const { getCurrencies, currencies } = utilsStore;

    //const { get, activity, reset } = activitiesStore;
    const { t, i18n } = useTranslation();    
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);   
    const [validated, setValidated] = useState(false);
    const messageForm = useRef(null);
    const isNew = () => id && id == "new";
    const [ibanFields, setIbans] = useState({});
    const [logo, setLogo] = useState("");
    const [header, setHeader] = useState("");
    const [uploading, setUploading] = useState(false);

    useEffect(() => {                
        setIsLoading(true);
        
        Promise.all(id == "new"? [getCurrencies()] : [getById(id), getCurrencies()]).then(() => {
            setIsLoading(false)
        });

        if (id == "new") {handleReset();} 

    }, [getById, reset]);

    useEffect(() => {
        setIbans(company.ibansPerCurrency?.reduce((obj, item) => (obj[`iban_${item.currencyId}`] = item.iban, obj), {}))
        setLogo(company.logo)
        setHeader(company.header)

    }, [company])

    const handleReset = () => {
        reset();        
        setValidated(false);
    };

    const getImages = () => {
        return { logo: logo };
    }
     
    const handleSubmit = (event) => {
        event.preventDefault();

        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            var formData = prepareForm(event, isNew(), ["id"]);
            //console.log(Object.entries(formData))

            formData.ibansPerCurrency = Object.keys(formData).filter(e => e.indexOf("iban_") > -1).map(x => { var obj = formData[x]; return { currencyId: Number(x.split("_")[1]), iban: obj } });
            Object.keys(formData).forEach((e, idx) => {
                if (e.indexOf("iban_") > -1) {                    
                    delete formData[e];
                }
            });

            //const data = new FormData();
            //Object.keys(formData).forEach(key => data.append(key, formData[key]));
            //data.append("logo", formData.logo);
            //console.log(data)

            save(formData, () => { goToList() });
        }

        setValidated(true);
    };

    const goToList = () => {
        navigate("/administration/companies")
    };

    const getIbans = () => {
        return cloneDeep(company.ibansPerCurrency?.reduce((obj, item) => (obj[`iban_${item.currencyId}`] = item.iban, obj), {}));
    }

    const toBase64 = (file, onSuccess) => {
        let reader = new FileReader();
        
        reader.onload = () => {onSuccess?.(reader.result.replace('data:', '').replace(/^.+,/, ''))};
        reader.readAsDataURL(file);
    }

    return (       
        <Form noValidate validated={validated} onSubmit={handleSubmit} ref={messageForm}>
            <Card>
                
                <Card.Body>
                    <div>                      
                        <Stack direction="vertical">
                            <Row>
                                <Col style={{ alignSelf: "center" }}  >
                                    <ArrowBackIosIcon sx={{ color: "#d12b3c", cursor: "pointer" }} onClick={() => navigate("../companies")} size="small" />

                                    <b>{t(isNew() ? 'newCompany' : 'company')}  {!isNew() && `(Id: ${id})`}</b>
                                </Col>
                                <Col md="auto"><Button className="btn btn-danger float-end" onClick={goToList} >{t('cancel')}</Button></Col>
                                <Col md="auto"><Button type="submit" className="btn btn-secondary float-end" >{t('save')}</Button></Col>
                            </Row>

                            <hr />

                            <Row className="my-2">
                                <Col xs={4}>
                                    <FormText hidden isNumber id="id" type="number" object={company} />
                                    <FormText required label={t("societyName")} id="name" isLoading={isLoading} object={company}/>
                                </Col>

                                <Col xs={4}>
                                    <FormText required label={t("winbizFile")} id="winbizFile" isLoading={isLoading} object={company} />


                                </Col>
                            </Row>

                            <Row className="my-2">
                                <Col xs={4}>
                                    <FormText required label={t("address")} id="address" isLoading={isLoading} object={company} />

                                </Col>
                                <Col xs={2}>
                                    <FormText required label={t("city")} id="city" isLoading={isLoading} object={company} />

                                </Col>

                                <Col xs={2}>
                                    <FormText required label={t("postalCode")} id="postalCode" isLoading={isLoading} object={company} />

                                </Col>

                            </Row>

                            <Row className="my-2">
                                <Col xs={4}>
                                    <FormText required label={t("phone")} id="phone" isLoading={isLoading} object={company} />
                                    
                                </Col>
                                <Col xs={2}>
                                    <FormText required type="email" label={t("email")} id="email" isLoading={isLoading} object={company} />
                                    
                                </Col>

                                <Col xs={2}>
                                    <FormText required label={t("website")} id="website" isLoading={isLoading} object={company} />
                                    
                                </Col>
                            </Row>

                            <Row className="my-2">
                                <Col xs={4}>
                                    <FormText required label={t("noTVA")} id="noTVA" isLoading={isLoading} object={company} />
                                    
                                </Col>

                            </Row>


                            {isLoading ? <Skeleton width={100} /> : <u>{t("bankInfo")}</u>}
                            <Row className="my-2">
                                <Col xs={4}>
                                    <FormText required lines={4} label={t("beneficiary")} id="beneficiary" isLoading={isLoading} object={company} />
                                </Col>

                                <Col xs={4}>
                                    <FormText required lines={2} label={t("bank")} id="bank" isLoading={isLoading} object={company} />                                    
                                </Col>

                            </Row>

                            <Row className="my-2">
                                <Col xs={8}>
                                    <FormText required label={t("swift")} id="swift" isLoading={isLoading} object={company} />                                    
                                </Col>

                                

                            </Row>                            

                            
                            {currencies?.map((c,i) => (                                
                                <Row className="my-2" key={i} >
                                    <Col xs={8}>
                                        <FormText label={`${t("iban")} (${c.shortName})`} id={`iban_${c.id}`} isLoading={isLoading} object={ibanFields} />
                                    </Col>
                                </Row>

                            ))}


                            <Row>
                                
                                <Col xs={4}>                                    
                                    <FormFileUpload label={`${t("logo")}: ${(logo ?? "")}`} isLoading={isLoading || uploading} accept=".jpg"                                    
                                        base64={company.logoBase64}
                                        onFileSelected={
                                        (f) => {
                                            var data = new FormData();
                                            data.append("file", f[0]);

                                            toBase64(f[0], (r) => runInAction(()=>company.logoBase64 = r));

                                            setUploading(true);
                                            uploadImage(data).then((c) => { setLogo(c); setUploading(false); });
                                        }
                                    } />

                                    
                                    <Form.Group>
                                        <Form.Control style={{ display: "none" }} onChange={() => { }} required name="logo" value={logo || ""} />
                                        <Form.Control.Feedback type="invalid">
                                            {t('fieldRequired')}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    </Col>
                                
                                <Col xs={4}>
                                    <FormFileUpload label={`${t("header")}: ${(header ?? "")}`} isLoading={isLoading} accept=".jpg"
                                        base64={company.headerBase64}
                                        onFileSelected={
                                        (f) => {
                                            var data = new FormData();
                                            data.append("file", f[0]);
                                            toBase64(f[0], (r) => runInAction(() => company.headerBase64 = r));
                                            setUploading(true);
                                            uploadImage(data).then((c) => { setHeader(c); setUploading(false); });
                                        }
                                    } />

                                    
                                    <Form.Group>
                                        <Form.Control style={{ display: "none" }} onChange={() => { }} required name="header" value={header || ""} />
                                        <Form.Control.Feedback type="invalid">
                                            {t('fieldRequired')}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                </Col>
                            </Row>
                            
                           

                        </Stack>

                    </div >

                </Card.Body>
            </Card>
        </Form>

    );
};

export default observer(CompaniesEdit);
